module.exports = __webpack_public_path__ + "static/media/jeff3.42e849c3.jpg";